import React from 'react';
import PropTypes from 'prop-types';
import Pill from './Pill';
import { PILL_SIZES } from './tones';

// A number: how many steps, which rank, how many milliseconds. Always quiet, so a count never
// reads as a status — a blue "3" next to a blue "In progress" claims a relationship that is not
// there. Figures are tabular so a column of them lines up.
export default function CountPill({ size, title, className, children }) {
  return (
    <Pill tone="quiet" size={size} shape="rect" tabular title={title} className={className}>
      {children}
    </Pill>
  );
}

CountPill.propTypes = {
  size: PropTypes.oneOf(PILL_SIZES),
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

CountPill.defaultProps = {
  size: 'standalone',
  title: undefined,
  className: '',
};
